<div id="explorer-container">

<!--    <article id="explorer-container" class="page-container row" ng-class="{'hidden': hideContent}"> -->

    <div id="sidenav">
        <nav id="ftep-nav-wrapper">

            <ul class="ftep-nav">
                <li (click)="tabService.toggleExplorerSidebar(tabService.explorerSideNavs.SEARCH)" 
                    [ngClass]="{'active': tabService.navInfo.explorer.sideViewVisible && tabService.navInfo.explorer.activeSideNav == 0}">
                    <i class="material-icons" data-bs-toggle="tooltip" title="Search" tooltip-placement="right">search</i>
                </li>
                <li (click)="tabService.toggleExplorerSidebar(tabService.explorerSideNavs.SERVICES)" 
                    [ngClass]="{'active': tabService.navInfo.explorer.sideViewVisible && tabService.navInfo.explorer.activeSideNav == 1}">
                    <i class="material-icons" data-bs-toggle="tooltip" title="Services" tooltip-placement="right">settings_remote</i>
                </li>
                <li (click)="tabService.toggleExplorerSidebar(tabService.explorerSideNavs.WORKSPACE)" 
                    [ngClass]="{'active': tabService.navInfo.explorer.sideViewVisible && tabService.navInfo.explorer.activeSideNav == 2}">
                    <i class="material-icons" data-bs-toggle="tooltip" title="Job configuration" tooltip-placement="right">settings_input_component</i>
                </li>
                <li (click)="tabService.toggleBottomView()"
                    class="bottom-link"
                    [ngClass]="{'active-bottom': tabService.getOpenedBottombar() != undefined && tabService.getOpenedBottombar() != tabService.bottomNavTabs.MESSAGES }">
                    <i class="material-icons" data-bs-toggle="tooltip" title="Data-Panel" tooltip-placement="right">visibility</i>
                </li>
                <li (click)="tabService.toggleBottomViewMessages()"
                    class="notification-container bottom-link"
                    [ngClass]="{'active-bottom': tabService.getOpenedBottombar() === tabService.bottomNavTabs.MESSAGES}">
                    <i class="material-icons" data-bs-toggle="tooltip" title="Messages" tooltip-placement="right">message</i>
    <!--                <span class="notification" ng-show="message.count !== 0">{{message.count}}</span> -->
                </li>
            </ul>
    
        </nav>
    </div>

<!--    <div id="side-container" class="col-xs-12 col-sm-12 col-md-4 col-xl-3 col-xxl-2 panel-container"> -->
    @if (tabService.navInfo.explorer.sideViewVisible) {
        <div id="side-container">
            <app-explorersidebar></app-explorersidebar>
        </div>
    }
    <app-map></app-map>
    @if (tabService.navInfo.explorer.bottomViewVisible()) {
        <div id="bottom-container">
            <app-explorerbottombar></app-explorerbottombar>
        </div>
    }
</div>